import { render } from "./ProjectTicketsSection.vue?vue&type=template&id=f8d684dc&scoped=true&ts=true"
import script from "./ProjectTicketsSection.vue?vue&type=script&lang=ts"
export * from "./ProjectTicketsSection.vue?vue&type=script&lang=ts"

import "./ProjectTicketsSection.vue?vue&type=style&index=0&id=f8d684dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d684dc"]])

export default __exports__